module.exports = __webpack_public_path__ + "static/media/2.d9ee6fe6.jpg";